import enLocale from 'element-ui/lib/locale/lang/en'
const en = {  //module.exports
  ...enLocale,
    home: {
      username: 'Username',
      password: 'Password',
      programmeHighlight: 'Programme Highlight',
      programme: 'Programme',
      showMore: 'Show More',
      grades: 'Grades',
      slogan0: "Confidently explore the world of mathematics",
      slogan1: 'Everything starts with understanding!',
      describe1: 'Provide two major modes to cater to different learning needs.',
      watch: 'Watch Video',
      slogan2: 'MathConcept Online Learning Platform',
      describe2: 'Mathconcept Online provides a comprehensive mathematical learning experience through ability assessments, animated short films, and a math question bank. The content is based on the curriculum development of the Education in Hong Kong Bureau and adapted from MathConcept\'s 100000 professional teaching material exercises and simulated test questions. It is suitable for online learning of primary school students from grade one to grade six.',
      slogan3: 'Effectively improving children\'s math skills',
      describe3: '(Introduction) When the mouth and mouth of important political figures were promoted, according to the great success of our country\'s history, they entered a period of time when the land economy and energy were not available? The transformation of the form of energy and energy has come to believe that love is the most important thing.',
      process: 'Subscription Process',
      banner1:
          "Transform into a math warrior to tackle challenges! Combining difficult problems designed based on Hong Kong's primary school curriculum, unlock maps and props, and easily master problem-solving skills through fun challenges！",
      banner2:
          "Gather a vast treasure trove of mathematical knowledge! Covering the entire curriculum of Hong Kong primary schools, it includes complete classic example questions and knowledge explanations. You can check and consolidate at any time to help improve mathematical ability！",
      describe4:
          "From the basic addition, subtraction, multiplication and division in Primary 1 to geometry and equations in Primary 6, you can master problem-solving logic through fun challenges in adventure mode, and deeply consolidate knowledge points in library mode. Covering the entire primary school curriculum, it gradually cultivates number sense and thinking ability, helping students easily cope with learning challenges of all grades！",
      describe5: "Register a customized account, conduct intelligent assessments to identify weaknesses, watch detailed lecture videos, consolidate knowledge through a vast amount of exercises, and take phase tests to check results, making progress clearly visible！",
      describe6: "Stand alongside millions of Hong Kong primary school students, break through yourself in fun learning, from consolidating basics to overcoming difficult problems, and easily gain mathematical ability and confidence！",
    },
    aboutUs: {
      title: "About Us",
      aboutMathConcept: "About MathConcept",
      mathConceptDesc1: "MathConcept was founded by a group of experienced mathematics education experts, including serving senior lecturers from the Faculty of Education at renowned Hong Kong universities, best-selling authors of primary and secondary school textbooks, experienced mathematics teachers, and teaching management professionals. We are committed to providing professional and comprehensive mathematics training for students aged 3 to 18.",
      mathConceptDesc2: "The first 'MathConcept Learning Center' opened in Olympian City. Currently, MathConcept has branches across various districts in Hong Kong, with over 20,000 students enrolled.",
      mathConceptOnlineIdea: "The Philosophy of MathConcept Online",
      onlineIdeaDesc1: "Our teaching team has invested substantial resources in developing teaching materials and creating operation and assessment systems tailored for the Hong Kong market from scratch. To date, 'MathConcept' has over 100,000 professional teaching materials and 104 registered publications, catering to the diverse needs of local and international school students aged 3 to 18, and dedicated to nurturing every child.",
      onlineIdeaDesc2: "We firmly believe that every child has unlimited potential. Our teaching team is committed to inspiring children's mathematical potential and helping them realize their dreams. We emphasize cultivating a positive learning attitude, understanding concepts, and connecting thinking to build children's confidence and interest in mathematics, directly enhancing their mathematics academic performance."
    },
    onlineLearning: {
      desc: "The platform focuses on 'integrating online and offline', enhancing physical classes through online resources, strengthening students' classroom experience, allowing parents to intuitively perceive the value of the courses, improving renewal rates while increasing attractiveness to physical students, helping branches retain students and expand enrollment scale, highlighting the professional advantages of tutorial centers.",
      heading1: "Physical Classes + Online Resources: Embark on 'Integrated' Efficient Learning",
      content1: "Each physical class is paired with corresponding teaching videos to consolidate knowledge, providing supplementary exercises and periodic tests. Parents can track learning data in real-time, intuitively witness progress, and strengthen the reputation and renewal rate of the tutorial center!",
      heading2: "Data-Driven, Customized Learning Plans",
      content2: "Teachers track students' learning progress in real-time through the platform. Based on accurate data analysis, they provide parents with personalized feedback on strengths and weaknesses, helping children leverage their strengths and improve efficiently!",
      heading3: "Full Coverage of Online and Offline, Seamless Learning Connection",
      content3: "No need to worry about missed classes! Platform teaching videos help catch up on progress; future data interoperability will enable online homework submission and correction, allowing teachers to accurately identify issues and double learning efficiency!",
      heading4: "Interactive Video Learning, Building a Graded Mathematics Knowledge System",
      content4: "Precisely classified by grade and unit (e.g., first-grade carry addition topics), interactive videos embed real-time quizzes (similar to Edpuzzle mode), tracking learning progress in real-time to ensure solid knowledge mastery!",
      motto: "Everything starts with understanding!",
      modeDesc: "Provide two major modes to cater to different learning needs"
    },
  step: {
    step1Title: "Step 1",
    step1Content: "Register",
    step2Title: "Step 2",
    step2Content: "Assess",
    step3Title: "Step 3",
    step3Content: "Watch",
    step4Title: "Step 4",
    step4Content: "Practice",
    step5Title: "Step 5",
    step5Content: "Test"
  },
  contact:{
    desc: "For any inquiries, please contact us through the following methods.",
  },
    // programmeList: {
    //   allGrades: 'All Grades',
    //   allTopics: 'All topics',
    //   allStars: 'All Levels',
    //   allStatus: 'All status',
    //   sortBy: 'Sort by',
    // },
    programmeList: {
      allGrades: '全部 年級',
      allTopics: '全部 主題',
      allStars: '全部 成績',
      allStatus: '全部 狀態',
      sortBy: '排序',
    },
    dashboard: {
      dashboard: 'Dashboard',
      parentAccount: 'Parent account',
      editAccount: 'Edit Account',
      deleteAccount: 'Delete Account',
      addAccount: 'Add account',
      studentSummary: 'Student Summary',
      purchaseHistory: 'Purchase History',
      studentAccount: 'Student account',
      logOut: 'Log Out',
    },
    programmeListDetail: {
      course: 'Course',
      buyNow: 'Buy Now',
      type: 'Type',
      addToCart: 'Add to Cart',
      aboutThisCourse: 'About this course',
      aboutThisProgramme: 'About this programme',
      trainingCompleted: 'Training Completed',
    },
    summaryOfArea: {
      summaryOfArea: 'Summary',
      myScore: 'My Score',
      backToHome: 'Back to Home',
      checkTheCorrect: 'Check the Correct',
      answerAtBelow: 'Answer at Below',
      practiceAgain: 'Practice Again!',
      unit: 'Unit',
      nextLesson: 'Next Lesson',
      completionLesson: 'Completion Lesson',
    },
    purchaseHistory: {
      purchaseHistory: 'Purchase History',
      date: 'Date',
      programme: 'Programme',
      assignedTo: 'Assigned to',
      amount: 'Amount',
    },
    other: {
      sortBy:'Sort By',
      summaryOf: 'Summary of',
      programme: 'Programme',
      completion: 'Completion',
      learnMore: 'Learn More',
      score: 'Score',
      start: 'Practice',
      about: 'About Us',
      platform: 'Online Learning',
      faq: 'FAQ',
      help: 'HELP',
      contact: 'Contact Us',
      contactText: 'If you have any inquiries, please contact us through the following methods.',
      sitemap: 'Sitemap',
      sitemapText: 'MathConcept Online',
      home: 'Home',
      refund: 'Refund Policy',
      privacy: 'Privacy Policy Statement',
      disclaimer: 'Terms of Service',
      order: 'Order',
      termsAndConditions: 'Terms and Conditions',
      version: 'MathConcept Education Limited. All rights reserved',
      login: 'Login',
      register: 'Register',
      exit: 'Log Out',
      next: 'Next',
      confirm: 'Confirm',//'Confirm',
      cancel: 'Cancel',//'Cancel',
      checkout: 'Checkout',
      total: 'Total',
      topic: 'Topic',
      notStartedYet: 'Not Started Yet',
      assignTo: 'Assign to',
      cart: 'Cart',
      cartWarning: 'Please select a student',
      programmeSuccess: 'Add to shopping cart successfully',
      forgetPasswordSuccess: 'Sending an email succeeded',
      orderError: 'Order Error',
      returnHome: 'return home',
      paymentFailure: 'payment failure',
      pleaseSelect: '請選擇',//'Please select',
      cartSummary: 'Cart Summary',
      successful: 'Your purchase was successful',
      orderConfirmation: 'Order Confirmation',
      termsCondition:'Terms and Conditions'
    },
    // account:{
    //   userName: 'Login Name',
    //   displayName: 'Display Name',
    //   gender: 'Gender',
    //   email: 'Email',
    //   oldPassword: 'Old Password',
    //   newPassword: 'New Password',
    //   studentAccount: 'Student Account Name',
    //   studentName: 'Student Name',
    //   school: 'School',
    //   grade: 'Grade',
    //   renew: 'Renew',
    //   addStudentAccount: 'Add Student',
    //   editAccount: 'Edit Account',
    //   editChildAccount: 'Edit Child Account',
    //   confirmPassword: 'Confirm Password',
    //   password: 'Password',
    //   passwordPlaceholder:'Please enter your password',
    //   parentInformation: 'Parent Information',
    //   resetPassword: 'Reset Password',
    //   birthday: 'birthday',
    // },
    account:{
      userName: '登錄名',
      displayName: '顯示名稱',
      gender: '性別',
      email: '電子郵件',
      oldPassword: '舊密碼',
      newPassword: '輸入新密碼',
      studentAccount: '學生帳戶名稱',
      studentName: '學生姓名',
      school: '學校',
      grade: '年級',
      renew: '續訂',
      addStudentAccount: '增加學生',
      editAccount: '編輯帳號',
      editChildAccount: '編輯學生資料',
      confirmPassword: '重複輸入新密碼',
      password: '密碼',
      passwordPlaceholder:'請輸入密碼',
      parentInformation: '父母信息',
      resetPassword: '重設密碼',
      birthday: '生日',
    },
  collection: {
    back: "Back",
    myCollection: "My Collection",
    loadingTip: "Loading...",
    allSeries: "All",
    allProperty: "All",
    holdCount: "Owned"
  },
      gacha: {
      luckyGacha: "Lucky Gacha",
      myCollection: "My Collection",
      loadingTip: "Loading, please wait...",
      saleTime: "Sale Period",
      startGacha: "Start Draw",
      gachaRunning: "Drawing...",
      remainChance: "You have {num} draw chance(s)!",
      congratsGet: "Congratulations you got",
      tip: "Notice",
      noChanceNow: "You don't have any draw chances now",
      howGetChance: "How to get draw chances",
      chanceRule: "1. Gain 2 stars or more in Adventure, Library or Homework mode to get one draw chance",
      noCardAvailable: "No cards available",
      gotIt: "Got it",
      status:{
        online:"Online",
        offline:"Offline"
      }
    },
    studentProgramme:{
      clearUp: "ClearUp",
      pencil: "Pencil",
      eraserRubbing: "Eraser Rubbing",
      cardDrawingChance: "You've got 1 chance for card drawing!",
      title:'My Programmes',
      aboutCourse:'About Course',
      lesson:'Lesson',
      startLearn:'Start to Learn',
      type:'Type',
      course:'Course',
      elaborate:'Elaborate',
      practice:'Practice',
      answerRecord:"My History",
      myFile:"My Profile",
      myGacha:"My Gacha",
      courseSwitching:"My Course",
      logOut: 'Log Out',
      category: 'Category',
      partOne: '|.Numbers & Operations',
      partTwo: '||.Shapes & Measurement',
      partThree: '|||.Applications & Thinking',
      topic: 'Topic',
      startDate: "Start Date",
      endDate: "End Date",
      finishDate: "Finish Date",
      score: "Mark",
      search: "Search",
      clearFilter: "Clear Filter",
      searchForExamKeywords: "Search for exam keywords",
      adventureMode:"Adventure",
      libraryMode:"Library",
      homework:"Homework",
      gacha:"Gacha",
      mode:"Mode",
      topicTitle:"Topic Title",
      practiseName:"Practise Name",
      duration:"Duration(Minutes)",
      scoreAndTotalScore:"Score/Total Score",
      review:"Review",
      accountName:"Account",
      subscriptionStatus:"Status",
      myGrade:"Grade",
      myGender:"Gender",
      myBirthday:"Birthday",
      branchSchool:"Center",
      courseVersion:"Course",
      setPicture:"Set profile picture",
      choosePicture:"Please choose a character as your profile picture.",
      update:"Update",
      switching:"Switch",
      guide1: "Choose the desired unit",
      guide2: "Select the topic",
      guide3: "Remeber to watch videos before practice. All videos are tailor-made for learning the concept.",
      guide4:"Skip",
      guide5:"Finish",
      guide6:"Next",
      error1:"Please select an avatar",
      watchTeaching:" Video",
      goPractice:"Practice",
      goExamine:"Examine",
      leave:"Back",
      leaveTitle:"Are you sure to leave?",
      leaveText:"The progress was saved",
      start:"Start",
      skip:"Skip",
      previousQuestion:"Previous",
      nextQuestion:"Next",
      finish:"Finish",
      reset:"Reset",
      cancel:"Cancel",
      confirm:"Confirm",
      submit:"Submit",
      submitSuccess:"Success！",
      submitting:"Submitting",
      submitTitle:"Confirm submission?",
      submitText1:"Unanswered questions!",
      questionNo: "",
      question: "Q",
      question2: " Right",
      solutionApproach: "SolutionApproach",
      answers: "Answers",
      answers2: "Answers",
      startGacha: "Start Gacha",
      issue: "Issue",
      finishAssessments: "Congratulations!",
      finishWork: "Congratulations!",
      finishAdventure: "Congratulations!",
      finishLibrary: "Congratulations!",
      commend1: 'Come on!',
      commend2: 'You are great!',
      commend3: 'Not bad!',
      commend4: 'You got ',
      small: "S",
      medium: "M",
      large: "L",
      issueText1: "Required field",
      issueText2: "What problem did you find? ",
      issueText3: "Return issue",
      issueText4: "Answer is incorrect",
      issueText5: "Found a typo",
      issueText6: "Misalignment or unable to display",
      issueText7: "Other questions",
      issueText8: "Describe the problem",
      issueText9: "Please provide your email address",
      rulesText1: "Please enter your email address",
      rulesText2: "Please enter a valid email address",
      rulesText3: "Please enter a problem description",
      rulesText4: "Please select the problem type",
      practice1: "Practice",
      coursesWitchingSuccessful: "Course switching successful",
      pleaseConductAnEvaluationFirst: "Please conduct an evaluation first",
      star:'Star',
      expire:'Expire',
      active:'Active',
      soon:'Soon',
      end:'End',
      assessmentTitle:' Assessment',
      assessmentText:'Assess math skills via tailored tests, enable intelligent analysis, and prioritize reinforcement topics.',
      sys1: 'Welcome to Student Platform!',
      sys2: 'Select a character as your avatar.',
      sys3: 'Student Platform Tutorial!',
      doHomeWork:'Start',
      istrue:'True',
      isfalse:'False',
      choiceQuestion: "Multiple Choice",
      judgeQuestion: "True/False",
      fillBlankQuestion: "Fill in the Blanks",
      arithmeticFixedQuestion: "Arithmetic (Fixed)",
      hotspotQuestion: "Hotspot",
      textDragQuestion: "Text Drag",
      connectionQuestion: "Matching",
      imageDragQuestion: "Image Drag",
      arithmeticVariableQuestion: "Arithmetic (Variable)",
      textDragClassifyQuestion: "Text Drag & Sort",
      matrixFillQuestion: "Matrix Fill"
    }
  }
  export default en;
